module.exports = __webpack_public_path__ + "img/load.018bc1bd.png";